/**
 * Contabilidad Module Index - Finance 360
 * Router for accounting module pages
 */

import { Routes, Route, Navigate } from 'react-router-dom';
import Dashboard from './Dashboard';
import PlanCuentas from './PlanCuentas';
import Asientos from './Asientos';
import AsientoForm from './AsientoForm';
import LibroMayor from './LibroMayor';
import BalanceGeneral from './BalanceGeneral';
import BalanceComprobacion from './BalanceComprobacion';
import EstadoResultados from './EstadoResultados';
import Bancos from './Bancos';
import ConciliacionBancaria from './ConciliacionBancaria';
import ReportesHacienda from './ReportesHacienda';
import Configuracion from './Configuracion';
import Dimensiones from './Dimensiones';
import Activos from './Activos';
import Prestamos from './Prestamos';
import FlujoCaja from './FlujoCaja';
import ReportesComparativos from './ReportesComparativos';
import Indicadores from './Indicadores';
import RequiereModulo from '../../components/RequiereModulo';
import DiferencialCambiario from '../reportes/DiferencialCambiario';

export default function ContabilidadModule() {
  return (
    <Routes>
      <Route index element={<Dashboard />} />
      <Route path="cuentas" element={<PlanCuentas />} />
      <Route path="asientos" element={<Asientos />} />
      <Route path="asientos/nuevo" element={<AsientoForm />} />
      <Route path="asientos/:id" element={<AsientoForm />} />
      <Route path="mayor" element={<LibroMayor />} />
      <Route path="mayor/:cuentaId" element={<LibroMayor />} />
      <Route path="balance" element={<BalanceGeneral />} />
      <Route path="comprobacion" element={<BalanceComprobacion />} />
      <Route path="resultados" element={<EstadoResultados />} />
      <Route path="bancos" element={<Bancos />} />
      <Route path="bancos/:id/conciliacion" element={<ConciliacionBancaria />} />
      <Route path="hacienda" element={<ReportesHacienda />} />
      <Route path="config" element={<Configuracion />} />
      {/* Las dimensiones contables: el catalogo vive en Finance (item 117) */}
      <Route path="dimensiones" element={<Dimensiones />} />
      <Route path="activos" element={<Activos />} />
      {/* Préstamos (S3) */}
      <Route path="prestamos" element={<Prestamos />} />
      <Route path="prestamos/:id" element={<Prestamos />} />
      {/* Flujo de caja proyectado (S4) */}
      <Route path="flujo-caja" element={<FlujoCaja />} />
      <Route path="comparativos" element={<ReportesComparativos />} />
      <Route path="indicadores" element={<RequiereModulo modulo="agro"><Indicadores /></RequiereModulo>} />
      {/* Diferencial cambiario (S5): la misma pantalla que en Reportes */}
      <Route path="diferencial-cambiario" element={<DiferencialCambiario />} />
      <Route path="*" element={<Navigate to="/contabilidad" replace />} />
    </Routes>
  );
}
